import _fragmentPageIndustryDetailTemplate from './_fragment-page-industry-detail-template'

const pageContentType = 'PageIndustrySaasPlatforms'

export default _fragmentPageIndustryDetailTemplate(pageContentType)
